import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBarService } from "app/core/services/snackbar-service/snackbar.service";

@Component({
    selector: "app-image-viewer",
    templateUrl: "./image-viewer.component.html",
    styleUrls: ["./image-viewer.component.scss"],
    standalone: true
})
export class ImageViewerComponent implements OnInit {
  public imageUrl: string;
  public imgAlt: string = "Image";
  constructor(private _snackBarService: MatSnackBarService) {}

  ngOnInit(): void {
    const url = sessionStorage.getItem('viewerUrl');
    if (url) {
      this.imageUrl = url;
      this.imgAlt = this.imageUrl.substring(this.imageUrl.lastIndexOf("/") + 1);
      sessionStorage.removeItem('viewerUrl'); // Clean up
    } else {
      this._snackBarService.error("Image not found");
    }
  }
}
